import Container from 'containers/home-page/views';
import { wrapper } from 'redux/store';

import withI18n from 'hocs/with-i18next';
import withHomePageLayout from 'hocs/with-home-page-layout';
import withBasicAuth from 'hocs/with-basic-auth';
import withParticipantAccess from 'hocs/with-participant-access';
import withCSPHeader from 'hocs/with-csp-header';
import withVisitsLogging from 'hocs/with-visits-logging';
import withHomePageAccess from 'hocs/with-home-page-access';

const locales = ['common', 'navigation', 'admin-layout', 'editor', 'footer'];

const Page = withVisitsLogging(withHomePageLayout(Container));

export const getServerSideProps = withParticipantAccess(
  withBasicAuth(
    withCSPHeader(
      withHomePageAccess(
        withI18n(
          wrapper.getServerSideProps(() => async () => {
            return { props: {} };
          }),
          locales,
        ),
      ),
    ),
  ),
);

export default Page;
